/**
 * Exports backdrop-related design tokens
 */

export const backgroundColor = 'black';
export const opacity = 0.75;
export const defaultTransitionDuration = 'medium';
export const transitionEasing = 'ease-in-out/medium';